import { ApplicationInsights } from '@microsoft/applicationinsights-web'

let appInsights: ApplicationInsights | null = null

export const initializeAppInsights = (): ApplicationInsights | null => {
  if (typeof window === 'undefined') return null
  if (appInsights) return appInsights

  const connectionString = process.env.NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING

  if (!connectionString) {
    console.warn('Application Insights connection string not configured')
    return null
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableResponseHeaderTracking: true
    }
  })

  appInsights.loadAppInsights()

  return appInsights
}

export const getAppInsights = (): ApplicationInsights | null => appInsights

export const trackPageView = (name?: string, uri?: string): void => {
  if (appInsights) {
    appInsights.trackPageView({
      name: name || document.title,
      uri: uri || window.location.href
    })
  }
}

export const trackEvent = (name: string, properties?: Record<string, string>): void => {
  if (appInsights) {
    appInsights.trackEvent({ name }, properties)
  }
}

export const trackException = (error: Error, properties?: Record<string, string>): void => {
  if (appInsights) {
    appInsights.trackException({ exception: error }, properties)
  }
}
